module.exports = __webpack_public_path__ + "img/btf_logo.91598f21.jpg";